import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ width = "100%" }) => css`
    width: ${width};
    position: relative;
    overflow: hidden;

    .eye-icon {
      position: absolute;
      top: 50%;
      right: 5px;
      cursor: pointer;
    }
  `}
`;
export const Wrapper = styled.div`
  ${({ theme }) => css`
    position: relative;
  `}
`;

export const Input = styled.input`
  ${({ theme }) => css`
    padding-left: 1rem;
    font-size: 1.5rem;
    border-radius: 5px;
    line-height: 4rem;

    width: 100%;
    height: 3.8rem;
    border: 1px solid ${theme.colors.graySecondary};
    margin-bottom: 0.5rem;
    ::placeholder {
      color: ${theme.colors.gray};
      font-style: italic;
      font-size: 1.5rem;
      font-family: Roboto !important;
    }
  `}
`;
export const LabelUnder = styled.label`
  ${({ theme, error }) => css`
    width: 100%;
    height: 100%;
    border: none;
    pointer-events: none;
    font-size: ${theme.font.sizes.medium};
    font-weight: 500;
    font-family: Roboto !important;
    color: #f00909;

    .content__name {
      position: absolute;
      bottom: 0.5rem;
      transition: all 0.3s ease-in-out;
    }

    &::after {
      content: "";
      position: absolute;
      height: 100%;
      width: 100%;
      left: 0;
      bottom: -1px;
      transform: translateX(-100%);
      transition: all 0.5s ease-in-out;
    }

    @media (min-width: 1600px) {
      font-size: ${theme.font.sizes.medium};
    }

    @media (max-width: 500px) {
      font-size: 1.2rem;
    }
  `}
`;

export const Label = styled.p`
  ${({ theme }) => css`
    font-weight: 500;
    padding-bottom: 1px;
    color: ${theme.colors.gray}!important;
    font-size: ${theme.font.sizes.medium} !important;
    font-family: Roboto !important;
    line-height: 2.5rem;
  `}
`;

export const IconWrapper = styled.div`
  ${({ theme }) => css`
    position: absolute;
    right: 0;
    bottom: 0;
    svg {
      color: ${theme.colors.primary};
    }
  `}
`;
